import React, { useState } from "react";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { light, dark } from "@pancakeswap-libs/uikit";

const CACHE_KEY = "IS_DARK";

export interface ThemeContextType {
  isDark: boolean;
  toggleTheme: () => void;
}

const ThemeContext = React.createContext<ThemeContextType>({
  isDark: false,
  toggleTheme: () => null,
});
const modTheme = {
  ...dark,
  colors: {
    ...dark.colors,
    primary: "#1da2e7",
    secondary: "#1da2e7",
    borderColor: "#1da2e7",
    background:
      "#050d2c",
    textSubtle: "#1da2e7",
    text: "#fff",
    tertiary: "#6c449c",
    failure: "#ab3f3d",
    input: "#000000b3",
    success: "#1da2e7",
    navBorder: "#1da2e7",
  },
  shadows: {
    ...dark.shadows,
    focus: "0px 0px 0px 1px #1da2e7, 0px 0px 0px 4px #1da2e799;",
  },
  nav: {
    ...dark.nav,
    background: "#1da2e7",
  },
  // tooltip:{
  //   ...dark.tooltip,
  //   background:'red'
  // }
  card: { ...dark.card, background: "#1da2e7" },
};

const ThemeContextProvider: React.FC = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const isDarkUserSetting = localStorage.getItem(CACHE_KEY);
    return isDarkUserSetting ? JSON.parse(isDarkUserSetting) : false;
  });

  const toggleTheme = () => {
    setIsDark((prevState: any) => {
      localStorage.setItem(CACHE_KEY, JSON.stringify(!prevState));
      return !prevState;
    });
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <SCThemeProvider theme={modTheme}>{children}</SCThemeProvider>
    </ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeContextProvider };
